export default __webpack_public_path__ + "media/fa1ab0895133d5229d68a8c931538ed5cd11582408bbb21872c44e2eb3aa2e35.svg";